import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { CardImageWrapper } from '../../components/icons/CardImageWrapper';

import amexIcon from '../../images/cards/amex.svg';
import discoverIcon from '../../images/cards/discover.svg';
import mastercardIcon from '../../images/cards/mastercard.svg';
import visaIcon from '../../images/cards/visa.svg';
import genericIcon from '../../images/cards/generic.svg';

interface Props {
  networkType?: string | null;
  lastFour?: string | null;
  cardArtUrl?: string | null;
  variant?: 'default' | 'compact';
}

const getIcon = (networkType: string, cardArtUrl?: string | null) => {
  if (cardArtUrl) {
    return cardArtUrl;
  }

  switch (networkType.toLowerCase()) {
    case 'amex':
      return amexIcon;
    case 'mastercard':
      return mastercardIcon;
    case 'visa':
      return visaIcon;
    case 'discover':
      return discoverIcon;
    default:
      return genericIcon;
  }
};

export const CardOnFileCell = ({
  networkType,
  lastFour,
  cardArtUrl,
  variant = 'default',
}: Props) => {
  if (!networkType || !lastFour) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <CardImageWrapper>
        <img src={getIcon(networkType, cardArtUrl)} alt={networkType} />
      </CardImageWrapper>
      <Box
        sx={{
          display: 'flex',
          ...(variant === 'default' && {
            flexDirection: 'row',
            gap: 0.5,
            alignItems: 'center',
          }),
          ...(variant === 'compact' && {
            flexDirection: 'column',
            gap: 0,
            alignItems: 'flex-start',
            width: '40px',
            pb: 0.25,
          }),
        }}
      >
        <Typography component="span">••••</Typography>
        <Typography component="span">{lastFour}</Typography>
      </Box>
    </Stack>
  );
};
